var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"headerImg",staticClass:"containter"},[_c('el-image',{staticStyle:{"width":"100%"},attrs:{"src":require('@/assets/images/header/kejiaohui-top.png'),"fit":"cover"},on:{"load":_vm.getImgHeight}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21feebdd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layoutKejiaohui/components/header.vue
// module id = null
// module chunks = 